export const users = [
  {
    path: '/users',
    name: 'Users',
    component: () => import('./index'),
    meta: {
      authRequired: true,
      rule: 'USERS',
      title: 'general.users',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/'
        },
        {
          text: 'general.users',
          disabled: true,
          href: '#/subscriptions'
        }
      ]
    }
  }
]